import React from 'react';
import Box from '../box';
import { useStyleConfig, vui } from '../core';
import { cs } from '../utils';
import { useHeaderContext } from './context';
/** Controls max-width of the content and centers itself horizontally. */
export const HeaderContent = vui((props, ref) => {
    const { className, ...rest } = props;
    const styles = useStyleConfig('Header', useHeaderContext());
    return (React.createElement(Box, { centerV: true, className: cs('vui-headerContent', className), h: 1, mx: "auto", ref: ref, w: 1, ...styles.content, ...rest }));
});
export default HeaderContent;
